import $ from 'jquery';

$('#thisisa').on('change', function () {
  var selectedValue = $(this).val();
  var form = $('#planner-form, #career-form'); // Select both possible IDs
  var budgetField = $('#projectbudget').closest('.text-field-container');
  var submitButton = $('#project-submit').closest('.button-contained');

  if (selectedValue === 'Career') {
      form.attr('id', 'career-form'); // Change ID to "career-form"
      submitButton.attr('form', 'career-form');
      budgetField.hide();
  } else {
      form.attr('id', 'planner-form'); // Change ID to "planner-form"
      submitButton.attr('form', 'planner-form');
      budgetField.show();
  }
}).trigger('change'); // Trigger change event on page load in case of preselected values


if ( $( '#planner-form, .register-form-js, #career-form' ).length ) {
  // REGEX validation
  // Email validation
  $( '#email' ).on( 'blur', function() {
    var Val = this.value;
    var email = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if ( !email.test( Val ) ) {
      $( this ).css( 'border-bottom', '1px solid red' );
    }
  });

  // Budget validation
  // let budgetValue
  
  // $( '#projectbudget' ).on( 'focus', function() {
  //   // if the value doesnt inclue a $ prepend it
  //   if ( this.value.indexOf( '$' ) === -1 ) {
  //     $( this ).val( '$' + $( this ).val() );
  //   }

  //   $( this ).on( 'input', function() {

  //     // test for non-digits
  //     if ( /\D/g.test( this.value ) ) {
  //       // Filter non-digits from input value.
  //       this.value = this.value.replace( /\D/g, '' );
  //     }
  //     // adding the formating to the number
  //     this.value = Number( $( this ).val() ).toLocaleString( 'en-CA' );

  //     // if the value doesnt inclue a $ prepend it
  //     if ( this.value.indexOf( '$' ) === -1 ) {
  //       $( this ).val( '$' + $( this ).val() );
  //     }
  //     budgetValue = this.value 
  //   });
  // });



  $( '#career-form' ).on( 'submit', function( e ) {
    e.preventDefault();
    // Remove $ and , from the budget field and convert to a Number
    // $( 'input[name=projectbudget]' ).val( Number( budgetValue.replace(/[^0-9]/g, '' ) ) )
    
    // $( 'html, body, .thank-you' ).scrollTop( 0 );

    $( '#career-form, .cta-wrapper' ).fadeToggle( 'slow', function() {
      $( '.thank-you' ).show();
    });
  });

  $( '#planner-form' ).on( 'submit', function( e ) {
    e.preventDefault();
    // Remove $ and , from the budget field and convert to a Number
    // $( 'input[name=projectbudget]' ).val( Number( budgetValue.replace(/[^0-9]/g, '' ) ) )
    
    // $( 'html, body, .thank-you' ).scrollTop( 0 );

    $( '#planner-form, .cta-wrapper' ).fadeToggle( 'slow', function() {
      $( '.thank-you' ).show();
    });
  });
}





if ( $( '.register-form-js' ).length ) {
  $( '.register-form-js' ).on( 'submit', function( e ) {
    e.preventDefault();

    $( '.form-container' )
      .animate( { opacity: 0 }, 400, function() {
        $( '.register-form-js' ).hide();
        $( '.thankYouHide' ).hide();
        $( '.thankYouShow' ).show();
        $( '.thankYouShow' ).addClass( 'thank-you-changed' );
      })
      .animate( { opacity: 1 }, 400 );
  });
}